import { useEffect } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { SuggestionModal } from "../components/SuggestionModal";
import { APPRADIO_ORIGIN } from "../lib/origins";

export function SsoLoginPage() {
  useEffect(() => {
    document.title = "Entrar · Radios.PRO";
    document.body.className = "rp-body";
    const params = new URLSearchParams(window.location.search);
    const next = params.get("next") || "/";
    try {
      sessionStorage.setItem("rpro_sso_next", next);
    } catch {
      /* ignore */
    }
    const authorize = new URL(APPRADIO_ORIGIN + "/sso/authorize");
    authorize.searchParams.set("redirect_uri", `${window.location.origin}/sso/callback`);
    authorize.searchParams.set("state", crypto.randomUUID ? crypto.randomUUID() : String(Date.now()));
    window.location.replace(authorize.toString());
  }, []);

  return (
    <>
      <Header />
      <SuggestionModal />
      <main className="rp-guide-page" style={{ minHeight: "50vh" }}>
        <article className="rp-guide-article">
          <header className="rp-guide-header">
            <p className="rp-guide-kicker">Conta</p>
            <h1>Entrar no Radios.PRO</h1>
            <p className="rp-guide-lead">
              Redirecionando para o login da sua conta AppRadio.pro. Depois do SSO você volta automaticamente para o
              Radios.PRO.
            </p>
          </header>
          <p>
            Se o redirecionamento não acontecer,{" "}
            <a href={`${APPRADIO_ORIGIN}/sso/authorize`}>abra o login AppRadio.pro</a>.
          </p>
        </article>
      </main>
      <Footer />
    </>
  );
}
